import axios from "axios";
import GraphContent from "../../components/graphContent/graph_content";
import SignalContent from "../../components/signalContent/signal_content";

import { AuthStoreType } from "../../types/types";
import AuthStoreAPI from "../../services/auth_store_service";
import { i18n } from "@/main";

/**
 * 保存ボタン通常状態
 * @param {SignalContent} self
 */
const switchDefault = (self: SignalContent) => {
  self.submitButton = true;
  self.submitWait = false;
  self.submitComplete = false;
};

/**
 * 保存ボタン保存中状態
 * @param {SignalContent} self
 */
const switchWait = (self: SignalContent) => {
  self.submitButton = false;
  self.submitWait = true;
  self.submitComplete = false;
};

/**
 * 保存ボタン保存成功状態
 * @param {SignalContent} self
 */
const switchSuccess = (self: SignalContent) => {
  self.submitButton = false;
  self.submitWait = false;
  self.submitComplete = true;
};

export class AuthStoreController {
  /**
   * 認証ストアの新規作成
   * @param self
   */
  public static async saveNew(self: GraphContent | SignalContent) {
    try {
      if (AuthStoreController.validationCheck(self)) {
        switchWait(self as SignalContent);
        const newAuth: AuthStoreType = await AuthStoreAPI.create(self);
        if (self.authStores === null) {
          self.authStores = [];
        }
        self.authStores.push(newAuth);
        switchSuccess(self as SignalContent);
        setTimeout(() => {
          switchDefault(self as SignalContent);
        }, 3000);
      }
    } catch (e) {
      console.error(e);
      switchDefault(self as SignalContent);
      alert(self.$t("message.failedToAddCredentialStore"));
    }
  }

  /**
   * 認証ストアの新規作成(初期設定フロー)
   * @param self
   */
  public static async saveNewDefaultSetting(self: GraphContent) {
    try {
      const newAuth: AuthStoreType = await AuthStoreAPI.createDefaultSetting(
        self
      );
      if (self.authStores === null) {
        self.authStores = [];
      }
      self.authStores.push(newAuth);
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * 認証ストアの削除
   * @param self
   */
  public static async remove(self: GraphContent | SignalContent) {
    try {
      let removeConfirmMessage: string = "";
      // 変数入りのメッセージが文法上おかしくないようif分岐
      if (i18n.locale === "ja") {
        removeConfirmMessage = (`\"${self.selectedAuthStore}\"` +
          self.$t(
            "message.areYouSureYouWantToDeleteCredentialStore"
          )) as string;
      } else {
        removeConfirmMessage =
          self.$t("message.areYouSureYouWantToDeleteCredentialStore") +
          `\"${self.selectedAuthStore}\"` +
          self.$t("message.questionMark");
      }
      const removeConfirm = confirm(removeConfirmMessage);
      if (removeConfirm) {
        const result = await AuthStoreAPI.delete(
          self.userID,
          self.selectedAuthStore
        );
        AuthStoreController.clear(self, result.store_name);
        self.authStoreProcessMsg = self.$t(
          "message.credentialStoreWasDeletedSuccessfully"
        ) as string;
        self.selectedAuthStore = "";
        setTimeout(() => {
          self.authStoreProcessMsg = "";
        }, 3000);
      }
      return;
    } catch (err) {
      console.error(err);
      alert(self.$t("message.failedToDeleteCredentialStore"));
      return err;
    }
  }

  /**
   * Component内のAuthStoresからremoveしたAuthStoreを削除
   * @param self
   * @param storeName
   */
  public static clear(self: GraphContent | SignalContent, storeName: string) {
    const removeIndex: number[] = [];
    self.authStores.forEach((store: AuthStoreType, index: number) => {
      if (storeName === store.store_name) {
        removeIndex.push(index);
      }
    });
    removeIndex.forEach((i: number) => {
      self.authStores.splice(i, 1);
    });
  }

  /**
   * 新規作成時のバリデーションチェック
   * @param self
   */
  public static validationCheck(self: GraphContent | SignalContent) {
    if (self.newStoreName === "") {
      alert(self.$t("message.nameCredentialStore"));
      return false;
    }
    if (self.newAccessKey === "") {
      alert(self.$t("message.enterAccessKey"));
      return false;
    }
    if (self.newSecretKey === "") {
      alert(self.$t("message.enterSecretAccessKey"));
      return false;
    }
    if (self.newRegion === "") {
      alert(self.$t("message.selectRegion"));
      return false;
    }
    return true;
  }

  /**
   * 新規作成時のバリデーションチェック(初期設定フロー)
   * @param self
   */
  public static validationCheckDefaultSetting(self: GraphContent) {
    if (
      self.active === 0 &&
      self.inputAuth === "" &&
      self.defaultAuth === true
    ) {
      self.stepAuthError = self.$t("message.nameCredentialStore") as string;
      return false;
    }
    if (
      self.active === 0 &&
      self.authStoreName === "" &&
      self.defaultAuth === false
    ) {
      self.stepAuthError = self.$t("message.selectCredentialStore") as string;
      return false;
    }
    if (
      self.active === 0 &&
      self.newDefaultSettingAccessKey === "" &&
      self.defaultAuth === true
    ) {
      self.stepAuthError = self.$t("message.enterAccessKey") as string;
      return false;
    }
    if (
      self.active === 0 &&
      self.newDefaultSettingSecretKey === "" &&
      self.defaultAuth === true
    ) {
      self.stepAuthError = self.$t("message.enterSecretAccessKey") as string;
      return false;
    }
    if (
      self.active === 0 &&
      self.newDefaultSettingRegion === "" &&
      self.defaultAuth === true
    ) {
      self.stepAuthError = self.$t("message.selectRegion") as string;
      return false;
    }
    self.stepAuthError = "";
    return true;
  }
}
